import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getReviews = async () => {
  const response = await axios.get(`${base_url}review/all`, getAuthHeaders());
  return response.data;
};

const reviewService = {
  getReviews,
};

export default reviewService;


// import axios from "axios";
// import { base_url } from "../../utils/baseUrl";

// const getReviews = async () => {
//   const response = await axios.get(`${base_url}review/all`);

//   return response.data;
// };

// const reviewService = {
//   getReviews,
// };

// export default reviewService;
